function processFacebookConversions() {
  try {
    function getCookie(name)
    {
        var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
     
        if(arr=document.cookie.match(reg))
     
            return decodeURIComponent(arr[2]);
        else
            return null;
    }
    
    // window.selfRequest = function (url, sendData) {
    //   try {
    //     var headers = {
    //       type: "application/json",
    //     };
    //     var blob = new Blob([JSON.stringify(sendData)], headers);
    //     navigator.sendBeacon(url, blob);
    //   } catch (error) {
    //     console.error(error);
    //   }
    // };
  	var distinct_id =  getCookie("sensorsdata2015jssdkcross")
    if (typeof distinct_id !== 'undefined') {
      distinct_id =(JSON.parse(distinct_id) || {}).distinct_id||'';
    }else{
      distinct_id=''
    }
    function getFBParams({ params }) {
      try {
        var FBParamsMap = {
          AddToCart: function (params) {
            return {
              num_items: (params["cd[num_items]"] || ""),
              content_type: (
                params["cd[content_type]"] || ""
              ),
              content_ids: JSON.parse(
                (params["cd[content_ids]"] || "[]")
              ),
              currency: (params["cd[currency]"] || ""),
              value:parseFloat(params["cd[value]"]),
              content_name: (
                params["cd[content_name]"] || ""
              ),
              event_source_url: (params.dl || ""),
              event_time: Number(String(new Date().getTime()).slice(0, 10)) - 1,
              event_id: params.eid,
              event_name: params.ev,
              user_id: params.id,
              distinct_id: distinct_id,
              fbc: params.fbc || "",
              fbp: params.fbp,
            };
          },
          ViewContent: function (params) {
            return {
              event_id: params.eid,
              event_name: params.ev,
              event_time: Number(String(new Date().getTime()).slice(0, 10)) - 1,
              event_source_url: params.dl || "",
              user_id: params.id,
              distinct_id: distinct_id,
              fbc: params.fbc || "",
              fbp: params.fbp,
              value:parseFloat(params["cd[value]"]),
              currency: (params["cd[currency]"] || ""),
              content_type: (
                params["cd[content_type]"] || ""
              ),
              content_name: (
                params["cd[content_name]"] || ""
              ),
              content_ids: JSON.parse(
                (params["cd[content_ids]"] || "[]")
              ),
            };
          },
          InitiateCheckout: function (params) {
            return {
              content_type: (
                params["cd[content_type]"] || ""
              ),
              content_ids: JSON.parse(
                (params["cd[content_ids]"] || "[]")
              ),
              currency: (params["cd[currency]"] || ""),
              value:parseFloat(params["cd[value]"]),
              num_items: (params["cd[num_items]"] || ""),
              event_source_url: (params.dl || ""),
              fbc: params.fbc || "",
              fbp: params.fbp,
              event_time: Number(String(new Date().getTime()).slice(0, 10)) - 1,
              event_id: params.eid,
              event_name: params.ev,
              user_id: params.id,
              distinct_id: distinct_id,
            };
          },
          Purchase: function (params) {
            //处理手机区号
            var phMap = {"DE":"49","AT":"43","CH":"41","BE":"32","LU":"352","AX":"+358-18","AS":"+1-684","AD":"376","AI":"+1-264","AQ":"","AG":"+1-268","AW":"297","AU":"61","AZ":"994","BS":"+1-242","BH":"973","BD":"880","BB":"+1-246","BY":"375","BZ":"501","BM":"+1-441","BT":"975","BQ":"599","BA":"387","BV":"","BR":"55","IO":"246","VG":"+1-284","BN":"673","BG":"359","CV":"238","KH":"855","CA":"1","KY":"+1-345","CF":"236","CL":"56","CN":"86","CX":"61","CC":"61","CO":"57","KM":"269","CK":"682","HR":"385","CW":"599","CY":"357","CZ":"420","CD":"243","DK":"45","DJ":"253","DM":"+1-767","DO":"+1-809 and 1-829","SV":"503","GQ":"240","ER":"291","EE":"372","SZ":"268","FK":"500","FO":"298","FI":"358","FR":"33","GF":"594","PF":"689","TF":"","GM":"220","GI":"350","GR":"30","GL":"299","GP":"590","GU":"+1-671","GG":"+44-1481","GW":"245","GY":"592","HT":"509","HM":" ","HK":"852","HU":"36","IS":"354","IE":"353","IM":"+44-1624","IL":"972","IT":"39","CI":"225","JP":"81","JE":"+44-1534","KZ":"7","KE":"254","KI":"686","XK":"","KW":"965","KG":"996","LV":"371","LB":"961","LS":"266","LY":"218","LT":"370","MO":"853","MY":"60","MV":"960","MT":"356","MH":"692","MQ":"596","MR":"222","YT":"262","MX":"52","FM":"691","MD":"373","ME":"382","MS":"+1-664","MA":"212","MM":"95","NR":"674","NL":"31","AN":"599","NC":"687","NZ":"64","NU":"683","NF":"672","KP":"850","MK":"389","MP":"+1-670","NO":"47","OM":"968","PW":"680","PS":"970","PH":"63","PN":"870","PL":"48","PT":"351","PR":"+1-787 and 1-939","QA":"974","CG":"242","RE":"262","RO":"40","RU":"7","RW":"250","BL":"590","SH":"290","KN":"+1-869","LC":"+1-758","MF":"590","PM":"508","VC":"+1-784","WS":"685","ST":"239","SA":"966","RS":"381","CS":"381","SL":"232","SG":"65","SX":"599","SK":"421","SI":"386","SB":"677","ZA":"27","GS":"","KR":"82","SS":"211","ES":"34","SR":"597","SJ":"47","SE":"46","TW":"886","TH":"66","TL":"670","TK":"690","TO":"676","TT":"+1-868","TR":"90","TM":"993","TC":"+1-649","TV":"688","VI":"+1-340","AE":"971","GB":"44","US":"1","UM":"1","UZ":"998","VU":"678","VA":"379","VN":"84","WF":"681","EH":"212"};
            var phone =  Shopify && Shopify.checkout ? Shopify.checkout.shipping_address.phone:"";
            var country_code = Shopify && Shopify.checkout ? Shopify.checkout.shipping_address.country_code:"";
            var iso='';
            if(country_code&&phone){
              iso = phMap[country_code]||'';
              if(/\+/.test(iso)){
                iso = iso.replace(/\+|-| /g,"");
              }  
              // 去除加减号
              phone= phone.replace(/\+|-| /g,'')
              if(!new RegExp('^'+iso).test(phone)){
                // 有国家号的
                phone = iso+phone;
              }
              phone= phone.replace(new RegExp('\\(|\\)| |\\+|\\-','img'),'');

            }
            return {
              content_type: params["cd[content_type]"] || "",
              content_ids: JSON.parse(
                (params["cd[content_ids]"] || "[]")
              ),
              currency: (params["cd[currency]"] || ""),
              value:parseFloat(params["cd[value]"] || ""),
              content_name: (params["cd[content_name]"] || ""),
              num_items: (params["cd[num_items]"] || ""),
              event_source_url:  ( params.dl || ""),
              fbc: params.fbc || "",
              fbp: params.fbp,
              event_time: Number(String(new Date().getTime()).slice(0, 10)) - 1,
              event_id: params.eid,
              event_name: params.ev,
              user_id: params.id,
              distinct_id: distinct_id,
              email: Shopify && Shopify.checkout ? Shopify.checkout.email : "",
              ph: phone||"",
            };
          },
        };
        return (FBParamsMap[params.ev] || function () {})(params);
      } catch (error) {
        typeof sensors !== "undefined" && sensors.track('FBConversionsError',  {event_name_str: params.ev,error_msg:error.message,facebookIMGurl:  window.facebookIMGurl, event_source_url_str: ( params.dl || "")});
      }
    }
    Object.defineProperty(HTMLImageElement.prototype, "src", {
      get: function (url) {
        return this.getAttribute("src");
      },
      set: function (url) {
        if (url && url.indexOf("facebook") > -1) {
          window.facebookIMGurl = url
          var params = getUrlParams(decodeURIComponent(url));

          var reg = /^(AddToCart|ViewContent|InitiateCheckout|Purchase)$/g;
          if (reg.test(params.ev)) {
            var FBParams = getFBParams({ params });

            $.ajax({  
              type: "post",  
              url:  "https://collective-api.thehalara.com/api/fb_conversion_api/receivePixelData",  
              data: JSON.stringify(FBParams),  
              contentType: "application/json; charset=utf-8", 
            }).done(function(){
 				typeof sensors !== "undefined" && sensors.track("FBConversionsSuccess", {
                  event_name_str: params.ev,
                  facebookIMGurl: window.facebookIMGurl,
                  event_time_value: FBParams.event_time,
                  event_id_value: FBParams.event_id,
                });

            })
          }
        }
        this.setAttribute("src", url);
      },
    });
  } catch (error) {
    typeof sensors !== "undefined" && sensors.track('FBConversionsError',  {error_msg:error.message,facebookIMGurl:  window.facebookIMGurl });

  }
}
window.processFacebookConversions = processFacebookConversions;
window.processFacebookConversions();
